import {encryptByDES} from '@/utils/3DES';
import http from '@/utils/http.js'
import cryptoJs from 'crypto-js';


/*

先引入文件
解构出函数
三个参数：接口中间得面子，接口后面得名字，传入得数据，判断是否包含在request里面

*/

export const mdMIwen = async (BoName, FunName, Param,type,Token) => {
	//正式环境
	// const DevelopCode = 'CaiHuaMiniProgramNew2022_2'
	// const _key = '6D994561'; // 你的key值
	// const _iv = 'B1D05BC5'; // 你的偏移量
	//测试环境
	let DevelopCode = 'CaiHuaMiniProgram'
	let _key = ''; // 你的key值
	let _iv = ''; // 你的偏移量
	let privateKey =''

	if(type == '测试'){
		DevelopCode="CaiHuaMiniProgram"
		_key="86244A24"
		_iv="B1D05BC5"
		privateKey = "86244A24-A6AD-4C66-84BC-9D31E2DDBC56"
	}else if(type == '正式'){
		DevelopCode="CaiHuaMiniProgramNew2022_2"
		_key="6D994561"
		_iv="F7B221B3"
		privateKey = "6D994561-721A-4B28-BB5B-DB11F7B221B3"
	}else if(type == '灰度'){
		DevelopCode="CaiHuaMiniProgramNewGray"
		_key="AE61A0FE"
		_iv="E895639A"
		privateKey = "AE61A0FE-1AE2-47BE-8F2C-2081E895639A"
	}

	let ParamDic = Param

	if(FunName=='LoginBySignUserID'){
		let SendTime=Date.now()
		ParamDic = {
			DevelopCode,
			SendTime,
			Sign:cryptoJs.MD5(SendTime+privateKey).toString(),
			userId:Param,
			CustomerCode:''
		}
	}

	

	

	const info = {
		//接口中间得名字
		BoName,
		//接口后面得名字
		FunName,
		//参数
		ParamDic,
		Token
	}
	console.log('info', info);
	//转换字符串
	const json = JSON.stringify(info);

	//加密
	const str1 = encryptByDES(json, _key, _iv);
	//转换成最后请求形成
	var finalRequest = {
		Json: str1,
		DevelopCode
	};

	console.log('finalRequest', finalRequest);
	//最终请求体
	// var miwen = JSON.stringify(finalRequest);

	// console.log("miwen方法的最终请求体", miwen);
	// 发送请求
	const res = await http({
		url: '/api/Identity/CallSwaggerFunEnForm',
		method: 'post',
		data: finalRequest,
	})

	return res
}